import React, { useEffect, useRef } from 'react';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { modalEditState } from '../atoms';
import { DefaultModal } from '@/presentation/components';
import InputKV from '../../components/input-kv';
import ButtonKV from '../../components/button-kv';
import Styles from '../../styles/steps-styles.scss';
import { ALL_GRADES_ADD } from '@/presentation/constants/class-grades';
import { Select } from '../../components';
import { isMobile } from 'mobile-device-detect';
const ModalEdit = ({ editData, toggleModalEdit, modalEditStudent, validation, doEditRecord, isSmallGroup }) => {
    var _a, _b, _c;
    const [state, setState] = useRecoilState(modalEditState);
    const resetState = useResetRecoilState(modalEditState);
    const classGradeOptions = ALL_GRADES_ADD.map(item => ({
        value: `${item.value}`,
        label: `${item.label}`
    }));
    const formRef = useRef();
    const validate = (field) => {
        const { email, firstName, lastName } = state;
        const formData = { email, firstName, lastName };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.emailError || !!prev.firstNameError || !!prev.lastNameError })));
    };
    useEffect(() => {
        if (state.firstName)
            validate('firstName');
    }, [state.firstName]);
    useEffect(() => {
        if (state.lastName)
            validate('lastName');
    }, [state.lastName]);
    useEffect(() => {
        if (state.email)
            validate('email');
    }, [state.email]);
    useEffect(() => {
        console.log(editData, 'modal Edit');
        // resetState();
        setState(prev => {
            var _a, _b, _c, _d, _e, _f, _g;
            return (Object.assign(Object.assign({}, prev), { email: (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.email, firstName: (_b = editData === null || editData === void 0 ? void 0 : editData.record) === null || _b === void 0 ? void 0 : _b.firstName, lastName: (_c = editData === null || editData === void 0 ? void 0 : editData.record) === null || _c === void 0 ? void 0 : _c.lastName, classGrade: (_d = editData === null || editData === void 0 ? void 0 : editData.record) === null || _d === void 0 ? void 0 : _d.classGrade, title: ((_e = editData === null || editData === void 0 ? void 0 : editData.record) === null || _e === void 0 ? void 0 : _e.title) ? { value: (_f = editData === null || editData === void 0 ? void 0 : editData.record) === null || _f === void 0 ? void 0 : _f.title, label: (_g = editData === null || editData === void 0 ? void 0 : editData.record) === null || _g === void 0 ? void 0 : _g.title } : null }));
        });
    }, [editData]);
    useEffect(() => {
        if (state === null || state === void 0 ? void 0 : state.classGrade) {
            // console.log(editData, 'data editData?.classGrade');
            const findGrade = ALL_GRADES_ADD.find(data => data.label === (state === null || state === void 0 ? void 0 : state.classGrade));
            // console.log(findGrade);
            setState(prev => (Object.assign(Object.assign({}, prev), { grades: findGrade })));
        }
        else {
            setState(prev => (Object.assign(Object.assign({}, prev), { grades: [] })));
        }
    }, [state === null || state === void 0 ? void 0 : state.classGrade]);
    const closeModal = () => {
        toggleModalEdit(false);
        resetState();
    };
    const updateRecord = () => {
        var _a, _b;
        doEditRecord({
            email: state.email,
            firstName: state.firstName,
            lastName: state.lastName,
            title: (_a = state === null || state === void 0 ? void 0 : state.title) === null || _a === void 0 ? void 0 : _a.value,
            classGrade: (_b = state === null || state === void 0 ? void 0 : state.grades) === null || _b === void 0 ? void 0 : _b.label
        }, editData);
    };
    return (React.createElement(DefaultModal, { height: isMobile ? '65' : '58.38', hUnit: "vh", width: isMobile ? '80' : '53.89', wUnit: "vw", open: modalEditStudent, onClose: closeModal, showClose: true, overlayCustomStyles: { zIndex: 10000 } },
        React.createElement("div", { className: Styles.editDivContainer },
            React.createElement("form", { method: "post", className: Styles.editModalWrap, ref: formRef, style: { maxHeight: 400 } },
                React.createElement("h1", null, "Edit student"),
                React.createElement("div", { className: Styles.subtitle }, "Student Information"),
                React.createElement("div", { className: Styles.namesWrap },
                    React.createElement("div", { className: Styles.inputWrapLeft },
                        React.createElement(InputKV, { type: "text", name: "firstName", placeholder: "ie. Guy", label: "FIRST NAME", required: true, defaultValue: (_a = editData === null || editData === void 0 ? void 0 : editData.record) === null || _a === void 0 ? void 0 : _a.firstName, stateParam: modalEditState })),
                    React.createElement("div", { className: Styles.inputWrapRight },
                        React.createElement(InputKV, { type: "text", name: "lastName", placeholder: "ie. Green", label: "LAST NAME", required: true, defaultValue: (_b = editData === null || editData === void 0 ? void 0 : editData.record) === null || _b === void 0 ? void 0 : _b.lastName, stateParam: modalEditState })),
                    isSmallGroup && (React.createElement("div", { className: Styles.inputWrapRight },
                        React.createElement(Select, { name: "grades", label: "GRADE", required: true, placeholder: 'ie. 3rd', options: classGradeOptions, state: state, setState: setState })))),
                React.createElement("div", { className: Styles.emailWrap },
                    React.createElement(InputKV, { type: "email", name: "email", placeholder: "ie. hawkins@mail.com", label: "EMAIL", required: true, defaultValue: (_c = editData === null || editData === void 0 ? void 0 : editData.record) === null || _c === void 0 ? void 0 : _c.email, stateParam: modalEditState })),
                React.createElement("br", null),
                React.createElement("div", { className: Styles.btnWrap },
                    React.createElement(ButtonKV, { type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", onClick: updateRecord, testId: "btn-save-record", stateParam: modalEditState }, "Confirm"))))));
};
export default ModalEdit;
